"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultConverter = void 0;
var DefaultConverter = /** @class */ (function () {
    function DefaultConverter() {
    }
    DefaultConverter.prototype.canConvertToCustomFormat = function () {
        return true;
    };
    DefaultConverter.prototype.convertToCustomFormat = function (obj, inArray) {
        if (inArray && obj === undefined) {
            return null;
        }
        return obj;
    };
    DefaultConverter.prototype.canConvertFromCustomFormat = function () {
        return true;
    };
    DefaultConverter.prototype.convertFromCustomFormat = function (obj) {
        return obj;
    };
    return DefaultConverter;
}());
exports.DefaultConverter = DefaultConverter;
//# sourceMappingURL=DefaultConverter.js.map